<div class="dcc_card {{data.bgboxclass}}">
  <!-- =={{isBeats}}=={{beats_id}}== -->
    <a *ngIf="beats_id==0 && srcfrm=='4' && data.is_create_user==0 && data.plan_status==1"
       href="javascript:void(0)" class="dc_close"><i (click)="Delete()" class="icon-round_close"></i></a>
    <div class="dcc_cont_area">
        <div class="dtc_edit_card">

                <ng-container *ngIf="srcfrm!='1' && srcfrm!='4'">
                    <h2 (click)="$event.stopPropagation();GoToDetail(data.customer_id, data.team_meeting_plan_type)"  class="plana_dca_title">
                        <span>
                            <span class="pdt_title_txt">{{data.customer_name}}
                                 <span class="ptt_icon" *ngIf="data.googleFlag !='1' && this.isVerifiedFLG && data.is_verified"><i class="icon-verifi"></i></span>
                                 <span class="ptt_icon pti_unverifi" *ngIf="data.googleFlag !='1' && this.isVerifiedFLG && !data.is_verified"><i class="icon-unverifi"></i></span>
                                 <span *ngIf="data.classification_category != null && data.classification_category != '' && data.classification_category != 'undefined'
                                  && data.classification_category.toLowerCase() != 'unknown' " class="ptt_icon pti_category"
                                  [ngClass]="classificationCategoryClass(data)">{{data.classification_category}}</span>
                            </span>
                            <!-- <div class="dca_verifi_card" *ngIf="data.googleFlag !='1' && this.isVerifiedFLG">
                                <ng-container *ngIf="data.is_verified">
                                    <i class="icon-verifi"></i> Verified
                                </ng-container>
                                <ng-container *ngIf="!data.is_verified">
                                    <i class="icon-unverifi"></i> Unverified
                                    <ng-container *ngIf="srcfrm=='6'">
                                        <a href="javascript:void(0)" (click)="$event.stopPropagation();CallVerified(data)">Verify</a>
                                    </ng-container>
                                </ng-container>
                            </div> -->
                        </span>
                    </h2>
                </ng-container>
                <ng-container *ngIf="srcfrm=='1' || srcfrm=='4'">
                    <h2 (click)="$event.stopPropagation();GoToDetail(data.customer_id, data.team_meeting_plan_type)"  class="plana_dca_title">

                    <span class="">
                        
                            <span class="pdt_title_txt">{{data.customer_name}}
                                 
                                <span class="ptt_icon" *ngIf="data.googleFlag !='1' && this.isVerifiedFLG && data.is_verified"><i class="icon-verifi"></i></span>
                                <span class="ptt_icon pti_unverifi" *ngIf="data.googleFlag !='1' && this.isVerifiedFLG && !data.is_verified"><i class="icon-unverifi"></i></span>
                                <span *ngIf="data.classification_category != null && data.classification_category != '' && data.classification_category != 'undefined'
                                    && data.classification_category.toLowerCase() != 'unknown' " class="ptt_icon pti_category"
                                   [ngClass]="classificationCategoryClass(data)">{{data.classification_category}}</span>

                                <ng-container *ngIf="data.is_create_user==0">
                                    <span *ngIf="data.is_create_user==0 && data.plan_along_status_color==0 && data.tooltip_message!=''"
                                        class="tooltip ptt_notifi" attr.data-tooltip={{data.tooltip_message}} data-tooltip-pos="down"
                                        data-tooltip-length="medium" (click)="$event.stopPropagation();">
                                        <i class="icon-round_notfi"></i>
                                    </span>
                                    <span *ngIf="data.is_create_user==0 && data.plan_along_status_color==1 && data.tooltip_message!=''"
                                        class="tooltip ptt_notifi pdti_green" attr.data-tooltip={{data.tooltip_message}} data-tooltip-pos="down"
                                        data-tooltip-length="medium" (click)="$event.stopPropagation();">
                                        <i class="icon-round_notfi"></i>
                                    </span>
                                    <span *ngIf="data.is_create_user==0 && data.plan_along_status_color==2 && data.tooltip_message!=''"
                                        class="tooltip ptt_notifi pdti_red" attr.data-tooltip={{data.tooltip_message}} data-tooltip-pos="down"
                                        data-tooltip-length="medium" (click)="$event.stopPropagation();">
                                        <i class="icon-round_notfi"></i>
                                    </span>
                                </ng-container>
                                
                                <ng-container *ngIf="data.is_create_user==1 && data.team_meeting_plan_type ==3">
                                    <span *ngIf="data.is_create_user==1 && data.plan_along_status_color==0 && data.tooltip_message!=''"
                                        class="tooltip ptt_notifi" attr.data-tooltip={{data.tooltip_message}} data-tooltip-pos="down"
                                        data-tooltip-length="medium" (click)="$event.stopPropagation();">
                                        <i class="icon-round_notfi"></i>
                                    </span>
                                    <span *ngIf="data.is_create_user==1 && data.plan_along_status_color==1 && data.tooltip_message!=''"
                                        class="tooltip ptt_notifi pdti_green" attr.data-tooltip={{data.tooltip_message}} data-tooltip-pos="down"
                                        data-tooltip-length="medium" (click)="$event.stopPropagation();">
                                        <i class="icon-round_notfi"></i>
                                    </span>
                                    <span *ngIf="data.is_create_user==1 && data.plan_along_status_color==2 && data.tooltip_message!=''"
                                        class="tooltip ptt_notifi pdti_red" attr.data-tooltip={{data.tooltip_message}} data-tooltip-pos="down"
                                        data-tooltip-length="medium" (click)="$event.stopPropagation();">
                                        <i class="icon-round_notfi"></i>
                                    </span>
                                </ng-container>

                            </span>
                        

                        

                        

                        <!-- <div class="dca_verifi_card" *ngIf="data.googleFlag !='1' && this.isVerifiedFLG">
                            <ng-container *ngIf="data.is_verified">
                                <i class="icon-verifi"></i> Verified
                            </ng-container>
                            <ng-container *ngIf="!data.is_verified">
                                <i class="icon-unverifi"></i> Unverified
                                <ng-container *ngIf="srcfrm=='6'">
                                    <a href="javascript:void(0)" (click)="$event.stopPropagation();CallVerified(data)">Verify</a>
                                </ng-container>
                            </ng-container>
                        </div> -->
                    </span>
                    </h2>
                </ng-container>


            <a href="javascript:void(0)" *ngIf="edit_show && data.googleFlag !='1'" class="btn more_btn" mat-icon-button [matMenuTriggerFor]="menu1" ><i class="icon-verifi_more"></i></a>
            <mat-menu #menu1="matMenu" xPosition="before" class="mpc_logout_txt" >
                <ul class="dec_menu_list">
                    <li class="mat-menu-item" (click)="$event.stopPropagation();EditPopup(data.isEdit,data.customer_id)"><span><i class="icon-edit"></i></span> Edit</li>
                    <li class="mat-menu-item" (click)="AddPlan(data,k)"><span><i class="icon-plus_icon"></i></span> Add to Plan</li>
                    <li class="mat-menu-item" *ngIf="srcfrm=='6'" (click)="DigipinMap(data.customer_id,data.latitude,data.longitude,data.is_digipin)"><span><i class="icon-digipin"></i></span> Add DigiPin</li>
                    <li class="mat-menu-item" *ngIf="srcfrm=='6'" (click)="AddSeller(data.customer_id,data.meeting_city)"><span><i class="icon-plus_icon"></i></span> Sales Partner</li>
                    <!-- <li class="mat-menu-item" *ngIf="!data.is_verified && srcfrm=='6' && this.isVerifiedFLG" (click)="CallVerified(data)"><span><i class="icon-unverifi"></i></span>Verify</li> -->

                </ul>
            </mat-menu>

            <!-- <h2 class="plana_dca_title plana_toggle_title"> -->
                <!-- <span (click)="GoToDetail(data.customer_id, data.team_meeting_plan_type)" class="pdt_txt">{{data.customer_name}} -->

                    <span class="pdt_icon" *ngIf="srcfrm=='4' && data.is_create_user==1 && checkApproveRejectDate(data) && (data.plan_along_status == 0 || (data.plan_along_status == 1 && data.plan_along_with_status_sub_desc.indexOf('Accompany with') > -1) || data.plan_along_status == 2 )">

                        <div class="switch">
                            <input type="radio" id="{{k}}_2" value="2" name="{{k}}_switch" class="switch1"
                            [(ngModel)]="data.plan_along_status" (click)="ShowAcceptReject(1)"/>
                            <label for="{{k}}_2"></label>

                            <div *ngIf="data.is_create_user==1 && (data.plan_along_status == 0)">
                            <input  type="radio" id="{{k}}_0" value="0" name="{{k}}_switch" class="switch2"
                            [(ngModel)]="data.plan_along_status"/>
                            <label for="{{k}}_0" id="{{k}}_00"></label>
                        </div>

                            <input type="radio" id="{{k}}_1" value="1"  name="{{k}}_switch" class="switch3"
                            [(ngModel)]="data.plan_along_status" (click)="ShowAcceptReject(2);"/>
                            <label for="{{k}}_1"></label>
                            <div class="switch__inner"></div>
                        </div>

                    </span>
            <!-- </h2> -->

            <!-- <a href="javascript:void(0)" *ngIf="edit_show" (click)="$event.stopPropagation();EditMeeting()"
                class="btn"><i class="icon-edit"></i></a> -->
        </div>
        <p *ngIf="(srcfrm=='1' || srcfrm=='4') && data.team_meeting_plan_type ==3" class="date_time_txt">
             <span class=""><i class="icon-date"></i> {{data.team_meeting_from_to_date}}</span>
             <span class=""><i class="icon-time"></i> {{data.team_meeting_from_to_time}}</span>
        </p>

        <!-- <p *ngIf="(data.calendar_time_n != null && data.calendar_time_n != '')" class="date_time_txt">
            <span class=""><i class="icon-time"></i> {{data.calendar_time_n}}</span>
       </p> -->
        <p>{{getAddress(data)}}</p>
        <div class="dcca_icon_area dcl_get_txt">
            <div class="dccia_left" *ngIf="(data.googleFlag !='1')">
                <a href="javascript:void(0)"><i class="{{data.categoryclassname}}"></i>
                    {{data.subcategory_name}}</a>

                <a href="javascript:void(0)" class="get_dir_txt" (click)="getDirection()"><i class="icon-direction"></i>
                    <span>Get Direction</span>
                </a>
            </div>
            <div class="dccia_right">
                <a href="javascript:void(0)"><i [ngClass]="data.is_digipin ? 'icon-digipin' : 'icon-location_icon'"></i> <span class="dcr_warp_txt">{{data.display_roundoff_distance_in_km}}</span>
                    </a>
                     <a *ngIf="beats_id==0 && (data.calendar_time_n != null && data.calendar_time_n != '')" class="date_time_txt">
                        <i class="icon-time"></i> <span class="dcr_warp_txt">{{data.calendar_time_n}}</span>
                     </a>

                <a *ngIf=" (this.srcfrm==2 || this.srcfrm==3 ||this.srcfrm==4 ) && data.accompany_text != null && data.accompany_text != '' "
                    href="javascript:void(0)"><i class="icon-accompany"></i>
                    {{data.accompany_text}}
                </a>

            </div>
        </div>
    </div>
    <div class="dcc_btn_card bl_comp_btn" *ngIf="srcfrm =='4' && data.is_create_user==0 && data.plan_status==4 && data.plan_status_desc == 'Move' ">
        <button (click)="MainButtonEvent(data)">{{data.plan_status_desc}}</button>
        <!-- move-->
    </div>

    <div class="dcc_btn_card mp_comp_btn" *ngIf="srcfrm =='4' && data.is_create_user==0 && data.plan_status==4 && data.plan_status_desc != 'Move' ">
        <button>{{data.plan_status_desc}}</button>
        <!-- move to-->
    </div>
    <div class="dcc_btn_card mp_comp_btn" *ngIf="( srcfrm=='3' || srcfrm=='4') && data.is_create_user==0 && (data.plan_status==2 || data.plan_status==3 || data.plan_status==6 || data.plan_status==7 || data.plan_status==8)">
        <button>{{data.plan_status_desc}}</button>
        <!-- completed Cancelled deleted-->
    </div>
    <div class="dcc_btn_card" *ngIf="((srcfrm=='2' || srcfrm=='3' || srcfrm=='7') && (data.googleFlag =='1'))">
        <button (click)="$event.stopPropagation();addGoogleCustomer(data.place_id)">ADD {{data.displayCategoryName}}</button>
        <button (click)="$event.stopPropagation();mapGoogleCustomer(data.customer_name, data.meeting_address1, data.place_id, data.latitude, data.longitude)">LINK {{data.displayCategoryName}}</button>
    </div>


    <div class="dcc_btn_card" *ngIf=" (srcfrm =='3' || srcfrm =='4') && data.googleFlag !='1' && data.is_create_user==0 && data.plan_status==1">
        <button (click)="$event.stopPropagation();Call(data.mobile_no1)">Call</button>
        <button  [ngClass]="{'disable': MeetingEnabledDisalbed(data)}" (click)="GoToCheckinPage()">Meeting</button>
    </div>

    <div class="dcc_btn_card" *ngIf="srcfrm =='1' && data.googleFlag !='1' && data.is_create_user==0">
        <button (click)="Call(data.mobile_no1)">Call</button>
        <button  (click)="GoToCheckinPage()">Meeting</button>
    </div>

    <div class="dcc_btn_card" *ngIf="((srcfrm =='4' || srcfrm=='1') && data.googleFlag !='1' && data.is_create_user==1 && data.plan_along_status==1 && data.team_meeting_plan_type !=3)">
        <!-- approve -->
        <button (click)="$event.stopPropagation();Call(data.mobile_no1)">Call</button>
        <button  [ngClass]="{'disable': MeetingEnabledDisalbed(data)}" (click)="GoToCheckinPage()">Meeting</button>
    </div>

    <div class="dcc_btn_card" *ngIf="(srcfrm!='3' && srcfrm!='4' && srcfrm!='1' && data.googleFlag !='1')">

        <button (click)="$event.stopPropagation();Call(data.mobile_no1)">Call</button>
        <button  (click)="$event.stopPropagation();GoToCheckinPage()">Meeting</button>
    </div>



    <div class="dcc_btn_card mp_comp_btn" *ngIf="srcfrm=='1' && data.is_create_user==1 && (data.plan_along_status==0 || data.plan_along_status==1) && data.team_meeting_plan_type ==3">
        <!-- plan_along_status -->
        <button>{{data.plan_along_with_status_sub_desc}}</button>
        <!-- (click)="MainButtonEvent(obj)" -->

    </div>

    <div class="dcc_btn_card mp_comp_btn" *ngIf="srcfrm=='4' && data.is_create_user==1 && data.plan_along_status==1 && data.team_meeting_plan_type ==3">
        <!-- plan_along_status -->
        <button>{{data.plan_along_with_status_sub_desc}}</button>
        <!-- (click)="MainButtonEvent(data)" -->
    </div>
    <ng-container *ngIf="srcfrm=='4'">
        <span id="{{data.customer_id}}"></span>
    </ng-container>
    <div class="dcc_btn_card mp_comp_btn" *ngIf="srcfrm=='4' && data.is_create_user==1 && data.plan_along_status!=1">
        <!-- plan_along_status -->
        <button>{{data.plan_along_with_status_sub_desc}}</button>
        <!-- (click)="MainButtonEvent(data)" -->
    </div>

</div>

<app-CTVerify [data]="data" ></app-CTVerify>
<app-CTPlanMove [state]="state" [data]="data"   (CallParent)="SuccessRefresh($event)"  ></app-CTPlanMove>
<app-CTPlanReason  [state]="data"  [data]="data"  (CallParent)="SuccessRefresh($event)"  ></app-CTPlanReason>
<app-CTPlanRejection [state]="data" [data]="data"  (CallParent)="SuccessRefresh($event)" ></app-CTPlanRejection>
<!-- <app-GoogleMapCustomer (CallParent)="SuccessRefresh($event)"></app-GoogleMapCustomer> -->
<!-- <app-CTPlanCalendar  *ngIf="showAddPlanCalendar" [state]="plancalendarstate" (CallParent)="SuccessPlanCalendarRefresh($event)"></app-CTPlanCalendar> -->
<app-CDPlanAppointment #CDPlanAppointmentComponent   [contactList]="dropdownList" [dealList]="dealList"
    [meetingTypeList]="meetingTypeList" [customerid]="customerid" (CallParent)="CallParentPlan($event)">
  </app-CDPlanAppointment>
<app-CTDigipinMap #CTDigipinMapComponent 
     [customerid]="customerid" (CallParent)="CallParentDigipinMapSuccessRefresh($event)">
  </app-CTDigipinMap>

  <div class="popupu_card ci_popup_card pop_active_card"  *ngIf="divbeyondPopup">

        <div class="popup_inner">

            <a href="javascript:void(0)" (click)="divbeyondPopup=false" class="pc_close_btn"><i class="icon-close"></i></a>

            <div class="ci_popup_txt_area">

                <p class="cpta_img"><img src="assets/images/alert_icon.svg" alt=""></p>

                <p>Customer location is not within the permissible distance of the current location.</p>

                
            </div>
            <div class="ci_popup_btn_area">
                <button (click)="BeyandCancel()">CANCEL</button>

                <button (click)="BeyandYes()">YES</button>

            </div>

        </div>

    </div>

    <!-- seller popup start -->
    <div class="popupu_card ci_popup_card pop_active_card"  *ngIf="divsellerPopup">

        <div class="popup_inner">

            <a href="javascript:void(0)" (click)="SellerCancel()" class="pc_close_btn"><i class="icon-close"></i></a>

            <div class="ci_popup_txt_area">

                <h4>Add Sales Partner</h4>

                <div class="cpta_add_dst_card">

                    <div class="lcta_tbox" [ngClass]="{'error': this.sellerstate.seller.iserr}"  id="divcdseller" *ngIf="this.sellerstate.sellerList.length>0">
                        
                        <span>Select distributor/sub-distributor<span>*</span></span>  
                        
                        <div>
                            <ng-multiselect-dropdown  class="ddb_lst_add_card" 
                            [placeholder]="' '"
                            [settings]="dropdownSettings"  id="divpmet"
                            [data]="this.sellerstate.sellerList"
                            [(ngModel)]="this.sellerstate.seller.value"
                            (onSelect)="onItemSelect($event)"
                            (onDeSelect)="OnItemDeSelect($event)">
                            </ng-multiselect-dropdown>
    
                        </div>
                        
                        <span class="error_txt">{{this.sellerstate.seller.err_txt}}</span>
                        
                    </div>
    
                </div>
                
            </div>

            <div class="ci_popup_btn_area">
                <button (click)="SellerCancel()">CANCEL</button>

                <button (click)="SellerYes()">SAVE</button>

            </div>

        </div>

    </div>

    <!-- seller popup end -->